import { createFileRoute } from '@tanstack/react-router';
import { TemplatesListPage } from '@/features/templates/templates-list-page.js';

export const Route = createFileRoute('/_app/templates')({
  component: TemplatesListPage,
});
